import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/statistics/Index/translationStatistics",{
        params: {
          ...params
        }
    } )
}
function EXPORT(params) {
    return  axios.get("/statistics/Index/translationStatisticsExport",{
        params: {
            ...params
        }
    }  )
}

export default {
    GET_LIST,
    EXPORT,
};
